import {

  useEffect,

  useState,

} from "react";



import CrudModal from "components/crud/CrudModal";

import CrudInput from "components/crud/CrudInput";

import CrudSelect from "components/crud/CrudSelect";



import LocationCascade from "components/location/LocationCascade";



import {

  createSchool,

  updateSchool,

  checkSchoolDuplicate,

  getSchoolAssignableEmployees,

} from "services/api/schoolApi";



import {

  showSuccess,

  showError,

} from "utils/toast";





const INITIAL_FORM = {

  schoolCode: "",

  permanentSchoolId: "",



  name: "",

  alternateName: "",



  principalName: "",

  countryId: "",

  stateId: "",

  districtId: "",

  cityId: "",

  zoneId: "",

  areaId: "",

  beatId: "",

  territoryId: "",



  stateZone: "",

  type: "school",

  board: "",

  affiliationNumber: "",

  schoolLevel: "",

  classesFrom: "",

  classesTo: "",

  bookSuppliedThrough: "",
  bookSellerName: "",
  samplingTime: "",
  finalizationTime: "",

  addressLine1: "",

  addressLine2: "",

  pincode: "",



  studentStrength: "",

  teacherStrength: "",



  website: "",

  latitude: "",

  longitude: "",



  schoolCategory: "",

  targetCategory: "",



  lastVerifiedDate: "",



  assignedEmployeeId: "",

  assignedEmployeeIds: [],



  status: "active",

};





const INITIAL_BUSINESS = {

  currentPublisher: "",

  existingBooks: "",

  competitorBooks: "",

  potential: "",

  expectedOrder: "",

  remarks: "",

};





const EMPTY_CONTACT = {

  name: "",

  designation: "",

  department: "",

  phone: "",

  alternateMobile: "",

  email: "",

  whatsapp: "",

  decisionMakerLevel: "",

  preferredContactMethod: "",

  bestContactTime: "",

  isPrimary: false,

  consentSource: "",

};





export default function SchoolModal({

  open,

  onClose,

  reload,

  item,

}) {



  const isEdit =

    Boolean(item);





  const [

    loading,

    setLoading,

  ] = useState(false);





  const [

    employeeLoading,

    setEmployeeLoading,

  ] = useState(false);





  const [

    employees,

    setEmployees,

  ] = useState([]);





  const [

    form,

    setForm,

  ] = useState(

    INITIAL_FORM

  );





  const [

    contacts,

    setContacts,

  ] = useState([]);





  const [

    businessDetails,

    setBusinessDetails,

  ] = useState(

    INITIAL_BUSINESS

  );





  const [

    duplicateResult,

    setDuplicateResult,

  ] = useState(null);





  // =========================================================

  // EMPLOYEES

  // =========================================================



  const loadEmployees =

    async () => {



      try {



        setEmployeeLoading(

          true

        );



        const response =

          await getSchoolAssignableEmployees();





        const data =

          response?.data || {};





        const records =

          data?.employees ||

          data?.items ||

          data?.records ||

          response?.employees ||

          response?.items ||

          response?.records ||

          [];





        setEmployees(

          Array.isArray(records)

            ? records

            : []

        );



      } catch (error) {



        console.error(

          "Employee load error:",

          error

        );



        setEmployees([]);



      } finally {



        setEmployeeLoading(

          false

        );



      }



    };





  // =========================================================

  // OPEN / EDIT

  // =========================================================



  useEffect(() => {



    if (!open) {

      return;

    }





    loadEmployees();





    if (item) {



      setForm({



        schoolCode:

          item.schoolCode ||

          "",



        permanentSchoolId:

          item.permanentSchoolId ||

          "",



        name:

          item.name ||

          "",



        alternateName:

          item.alternateName ||

          "",





        principalName:
          item.principalName ||
          "",

        countryId:

          item.location?.country?.id ||

          "",



        stateId:

          item.location?.state?.id ||

          "",



        districtId:

          item.location?.district?.id ||

          "",



        cityId:

          item.location?.city?.id ||

          "",



        zoneId:

          item.location?.zone?.id ||

          "",



        areaId:

          item.location?.area?.id ||

          "",



        beatId:

          item.location?.beat?.id ||

          "",



        territoryId:

          item.location?.territory?.id ||

          "",





        stateZone:
          item.stateZone ||
          "",

        type:

          item.type ||

          "school",



        board:

          item.board ||

          "",



        affiliationNumber:

          item.affiliationNumber ||

          "",




        schoolLevel:

          item.schoolLevel ||

          "",



        classesFrom:

          item.classesFrom ||

          "",



        classesTo:

          item.classesTo ||

          "",





        bookSuppliedThrough:
          item.bookSuppliedThrough ||
          "",

        bookSellerName:
          item.bookSellerName ||
          "",

        samplingTime:
          item.samplingTime ||
          "",

        finalizationTime:
          item.finalizationTime ||
          "",

        addressLine1:

          item.addressLine1 ||

          "",



        addressLine2:

          item.addressLine2 ||

          "",



        pincode:

          item.pincode ||

          "",





        studentStrength:

          item.studentStrength ??

          "",



        teacherStrength:

          item.teacherStrength ??

          "",





        website:

          item.website ||

          "",



        latitude:

          item.latitude ??

          "",



        longitude:

          item.longitude ??

          "",





        schoolCategory:

          item.schoolCategory ||

          "",



        targetCategory:

          item.targetCategory ||

          "",



        lastVerifiedDate:

          item.lastVerifiedDate

            ? String(

              item.lastVerifiedDate

            ).substring(0, 10)

            : "",





        assignedEmployeeId:

          item.assignedEmployee?.id ||

          "",



        assignedEmployeeIds:

          item.assignedEmployees?.map(

            (employee) =>

              String(employee.id)

          ) || [],





        status:

          item.status ||

          "active",



      });





      setContacts(

        item.contacts?.map(

          (contact) => ({

            ...EMPTY_CONTACT,

            ...contact,

          })

        ) || []

      );





      setBusinessDetails({



        currentPublisher:

          item.businessDetails

            ?.currentPublisher ||

          "",



        existingBooks:

          item.businessDetails

            ?.existingBooks ||

          "",



        competitorBooks:

          item.businessDetails

            ?.competitorBooks ||

          "",



        potential:

          item.businessDetails

            ?.potential ||

          "",



        expectedOrder:

          item.businessDetails

            ?.expectedOrder ||

          "",



        remarks:

          item.businessDetails

            ?.remarks ||

          "",



      });





    } else {



      setForm({

        ...INITIAL_FORM,

      });



      setContacts([]);



      setBusinessDetails({

        ...INITIAL_BUSINESS,

      });



    }





    setDuplicateResult(

      null

    );



  }, [

    open,

    item,

  ]);





  // =========================================================

  // FORM CHANGE

  // =========================================================



  const handleChange = (

    event

  ) => {



    const {

      name,

      value,

    } = event.target;





    setForm(

      (previous) => ({

        ...previous,

        [name]: value,

      })

    );



  };





  // =========================================================

  // CONTACT

  // =========================================================



  const updateContact = (

    index,

    key,

    value

  ) => {



    setContacts(

      (previous) =>

        previous.map(

          (contact, currentIndex) =>

            currentIndex === index

              ? {

                ...contact,

                [key]: value,

              }

              : contact

        )

    );



  };





  const addContact = () => {



    setContacts(

      (previous) => [

        ...previous,

        {

          ...EMPTY_CONTACT,

        },

      ]

    );



  };





  const removeContact = (

    index

  ) => {



    setContacts(

      (previous) =>

        previous.filter(

          (_, currentIndex) =>

            currentIndex !== index

        )

    );



  };





  // =========================================================

  // EMPLOYEE ASSIGNMENT

  // =========================================================



  const handleEmployeeChange = (

    employeeId,

    checked

  ) => {



    setForm(

      (previous) => {



        const current =

          previous.assignedEmployeeIds ||

          [];



        const normalized =

          current.map(String);





        let next;



        if (checked) {



          next = normalized.includes(

            String(employeeId)

          )

            ? normalized

            : [

              ...normalized,

              String(employeeId),

            ];



        } else {



          next =

            normalized.filter(

              (id) =>

                id !==

                String(

                  employeeId

                )

            );



        }





        return {

          ...previous,



          assignedEmployeeIds:

            next,



          assignedEmployeeId:

            next[0] || "",

        };



      }

    );



  };





  // =========================================================

  // BUILD PAYLOAD

  // =========================================================



  const buildPayload = () => {



    const employeeIds =

      (

        form.assignedEmployeeIds ||

        []

      ).map(String);





    return {



      schoolCode:

        form.schoolCode

          .trim(),



      name:

        form.name

          .trim(),



      alternateName:

        form.alternateName

          .trim() ||

        undefined,





      principalName:
        form.principalName
          .trim() ||
        undefined,

      countryId:

        form.countryId ||

        undefined,



      stateId:

        form.stateId ||

        undefined,



      districtId:

        form.districtId ||

        undefined,



      cityId:

        form.cityId ||

        undefined,



      zoneId:

        form.zoneId ||

        undefined,



      areaId:

        form.areaId ||

        undefined,



      beatId:

        form.beatId ||

        undefined,



      territoryId:

        form.territoryId ||

        undefined,





      stateZone:
        form.stateZone
          .trim() ||
        undefined,

      type:

        form.type,



      board:

        form.board

          .trim() ||

        undefined,



      affiliationNumber:

        form.affiliationNumber

          .trim() ||

        undefined,



      schoolLevel:

        form.schoolLevel

          .trim() ||

        undefined,



      classesFrom:

        form.classesFrom

          .trim() ||

        undefined,



      classesTo:

        form.classesTo

          .trim() ||

        undefined,





      bookSuppliedThrough:
        form.bookSuppliedThrough ||
        undefined,

      bookSellerName:
        form.bookSellerName
          .trim() ||
        undefined,

      samplingTime:
        form.samplingTime ||
        undefined,

      finalizationTime:
        form.finalizationTime ||
        undefined,

      addressLine1:

        form.addressLine1

          .trim() ||

        undefined,



      addressLine2:

        form.addressLine2

          .trim() ||

        undefined,



      pincode:

        form.pincode

          .trim() ||

        undefined,





      studentStrength:

        form.studentStrength !==

          ""

          ? Number(

            form.studentStrength

          )

          : undefined,



      teacherStrength:

        form.teacherStrength !==

          ""

          ? Number(

            form.teacherStrength

          )

          : undefined,





      website:

        form.website

          .trim() ||

        undefined,



      latitude:

        form.latitude !== ""

          ? Number(

            form.latitude

          )

          : undefined,



      longitude:

        form.longitude !== ""

          ? Number(

            form.longitude

          )

          : undefined,





      schoolCategory:

        form.schoolCategory

          .trim() ||

        undefined,



      targetCategory:

        form.targetCategory

          .trim() ||

        undefined,



      lastVerifiedDate:

        form.lastVerifiedDate ||

        undefined,





      assignedEmployeeId:

        employeeIds[0] ||

        undefined,



      assignedEmployeeIds:

        employeeIds,





      status:

        form.status,





      // -----------------------------------------------------

      // Existing business-details compatibility

      // -----------------------------------------------------



      businessDetails: {



        currentPublisher:

          businessDetails.currentPublisher

            ?.trim() ||

          undefined,



        existingBooks:

          businessDetails.existingBooks

            ?.trim() ||

          undefined,



        competitorBooks:

          businessDetails.competitorBooks

            ?.trim() ||

          undefined,



        studentStrength:

          form.studentStrength !==

            ""

            ? Number(

              form.studentStrength

            )

            : undefined,



        potential:

          businessDetails.potential

            ?.trim() ||

          undefined,



        expectedOrder:

          businessDetails.expectedOrder

            ?.trim() ||

          undefined,



        remarks:

          businessDetails.remarks

            ?.trim() ||

          undefined,



      },





      // -----------------------------------------------------

      // Contacts

      // -----------------------------------------------------



      contacts:

        contacts

          .filter(

            (contact) =>

              contact.name

                ?.trim()

          )

          .map(

            (contact) => ({



              name:

                contact.name

                  .trim(),



              designation:

                contact.designation

                  ?.trim() ||

                undefined,



              department:

                contact.department

                  ?.trim() ||

                undefined,



              phone:

                contact.phone

                  ?.trim() ||

                undefined,



              alternateMobile:

                contact.alternateMobile

                  ?.trim() ||

                undefined,



              email:

                contact.email

                  ?.trim() ||

                undefined,



              whatsapp:

                contact.whatsapp

                  ?.trim() ||

                undefined,



              decisionMakerLevel:

                contact.decisionMakerLevel

                  ?.trim() ||

                undefined,



              preferredContactMethod:

                contact.preferredContactMethod

                  ?.trim() ||

                undefined,



              bestContactTime:

                contact.bestContactTime

                  ?.trim() ||

                undefined,



              isPrimary:

                Boolean(

                  contact.isPrimary

                ),



              consentSource:

                contact.consentSource

                  ?.trim() ||

                undefined,



            })

          ),



    };



  };





  // =========================================================

  // VALIDATION

  // =========================================================



  const validateForm = () => {



    if (

      !form.schoolCode.trim()

    ) {

      showError(

        "School Code is required."

      );



      return false;

    }





    if (

      !form.name.trim()

    ) {

      showError(

        "School Name is required."

      );



      return false;

    }





    if (

      !form.countryId

    ) {

      showError(

        "Country is required."

      );



      return false;

    }





    if (

      !form.stateId

    ) {

      showError(

        "State is required."

      );



      return false;

    }





    if (

      !form.districtId

    ) {

      showError(

        "District is required."

      );



      return false;

    }





    if (

      !form.cityId

    ) {

      showError(

        "City / Town is required."

      );



      return false;

    }





    return true;



  };





  // =========================================================

  // SUBMIT

  // =========================================================



  const handleSubmit =

    async (event) => {



      event.preventDefault();





      if (

        !validateForm()

      ) {

        return;

      }





      try {



        setLoading(

          true

        );





        const payload =

          buildPayload();





        // ===================================================

        // DUPLICATE VALIDATION

        // ===================================================



        if (!isEdit) {



          try {



            const duplicateResponse =

              await checkSchoolDuplicate(

                payload

              );





            setDuplicateResult(

              duplicateResponse

            );





            const duplicateData =

              duplicateResponse?.data ||

              {};





            const score = Number(

              duplicateData?.duplicateScore ??

              duplicateData?.score ??

              0

            );





            const requiresReview =

              duplicateData?.requiresManualReview ===

              true ||

              duplicateData?.decision ===

              "manual_review" ||

              score >= 80;





            if (

              requiresReview

            ) {



              const proceed =

                window.confirm(

                  `Possible duplicate school detected (${score}% match). Do you want to continue?`

                );





              if (!proceed) {



                setLoading(

                  false

                );



                return;



              }



            }



          } catch (

          duplicateError

          ) {



            /*

            Duplicate validation failure should not

            destroy the normal School form.



            The backend create API remains the final

            authority.

            */



            console.warn(

              "Duplicate check unavailable:",

              duplicateError

            );



          }



        }





        // ===================================================

        // CREATE / UPDATE

        // ===================================================



        if (

          isEdit

        ) {



          await updateSchool(

            item.id,

            payload

          );





          showSuccess(

            "School updated successfully."

          );



        } else {



          await createSchool(

            payload

          );





          showSuccess(

            "School created successfully."

          );



        }





        await reload();



        onClose();



      } catch (

      error

      ) {



        console.error(

          "School save error:",

          error

        );





        const message =

          error?.response

            ?.data

            ?.message;





        if (

          Array.isArray(

            message

          )

        ) {



          showError(

            message.join(

              ", "

            )

          );



        } else {



          showError(

            message ||

            "Something went wrong."

          );



        }



      } finally {



        setLoading(

          false

        );



      }



    };





  // =========================================================

  // CLOSED

  // =========================================================



  if (!open) {

    return null;

  }





  // =========================================================

  // RENDER

  // =========================================================



  return (



    <CrudModal



      open={open}



      title={

        isEdit

          ? `Edit School ${item?.permanentSchoolId

            ? `— ${item.permanentSchoolId}`

            : ""

          }`

          : "Create School"

      }



      loading={loading}



      submitText={

        isEdit

          ? "Update"

          : "Create School"

      }



      onClose={onClose}



      onSubmit={handleSubmit}



      width="max-w-6xl"



    >



      <div className="space-y-8">



        {/* =====================================================

            SCHOOL IDENTITY

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            School Identity

          </h3>



          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">



            {isEdit && (

              <CrudInput

                label="Permanent School ID"

                value={

                  form.permanentSchoolId

                }

                disabled

              />

            )}



            <CrudInput

              label="School Code"

              name="schoolCode"

              value={form.schoolCode}

              onChange={handleChange}

              required

              disabled={isEdit}

            />



            <CrudInput

              label="School Name"

              name="name"

              value={form.name}

              onChange={handleChange}

              required

            />



            <CrudInput

              label="Alternate / Short Name"

              name="alternateName"

              value={form.alternateName}

              onChange={handleChange}

            />

            <CrudInput
              label="Principal Name"
              name="principalName"
              value={form.principalName}
              onChange={handleChange}
            />



            <CrudSelect

              label="School Type"

              value={form.type}

              onChange={(e) =>

                setForm({

                  ...form,

                  type: e.target.value,

                })

              }

              options={[

                {

                  value: "missionary-school",

                  label: "Missionary School",

                },

                {

                  value: "group-of-school",

                  label: "Group Of School",

                },

                {

                  value: "diocese-school",

                  label: "Diocese School",

                },

                {

                  value: "corporate-school",

                  label: "Corporate School",

                },

                {

                  value: "trust",

                  label: "Trust",

                },

                {

                  value: "society-school",

                  label: "Society School",

                },

                {

                  value: "book-seller-supply-school",

                  label: "Book Seller Supply School",

                },

                {

                  value: "private",

                  label: "Private",

                },

                {

                  value: "government",

                  label: "Government",

                },

              ]}

            />



            <CrudSelect
              label="Board"
              value={form.board}
              onChange={(e) =>
                setForm({
                  ...form,
                  board: e.target.value,
                })
              }
              options={[
                { value: "", label: "Select Board" },
                { value: "CBSE", label: "CBSE" },
                { value: "ICSE", label: "ICSE" },
                { value: "State Board", label: "State Board" },
                { value: "IB", label: "IB" },
                { value: "Cambridge", label: "Cambridge" },
                { value: "Other", label: "Other" },
                ...(form.board &&
                  !["CBSE", "ICSE", "State Board", "IB", "Cambridge", "Other"].includes(form.board)
                  ? [{ value: form.board, label: form.board }]
                  : []),
              ]}
            />



            <CrudInput

              label="Affiliation Number"

              name="affiliationNumber"

              value={form.affiliationNumber}

              onChange={handleChange}

            />



            <CrudInput

              label="School Level"

              name="schoolLevel"

              value={form.schoolLevel}

              onChange={handleChange}

              placeholder=""

            />



          </div>



        </section>





        {/* =====================================================

            LOCATION

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            School Geography

          </h3>



          <LocationCascade

            form={form}

            setForm={setForm}

          />

          <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
            <CrudInput
              label="State Zone"
              name="stateZone"
              value={form.stateZone}
              onChange={handleChange}
            />
          </div>



        </section>





        {/* =====================================================

            ADDRESS

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            Address

          </h3>



          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">



            <CrudInput

              label="Complete Address"

              name="addressLine1"

              value={form.addressLine1}

              onChange={handleChange}

            />



            <CrudInput

              label="Address Line 2"

              name="addressLine2"

              value={form.addressLine2}

              onChange={handleChange}

            />



            <CrudInput

              label="PIN Code"

              name="pincode"

              value={form.pincode}

              onChange={handleChange}

            />



          </div>



        </section>





        {/* =====================================================

            SCHOOL STRENGTH

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            School Strength

          </h3>



          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">



            <CrudInput

              label="Student Strength"

              name="studentStrength"

              type="number"

              value={

                form.studentStrength

              }

              onChange={handleChange}

              min="0"

            />



            <CrudInput

              label="Teacher Strength"

              name="teacherStrength"

              type="number"

              value={

                form.teacherStrength

              }

              onChange={handleChange}

              min="0"

            />



          </div>



        </section>





        {/* =====================================================

            WEB / GPS

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            Website & GPS

          </h3>



          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">



            <CrudInput

              label="Website"

              name="website"

              value={form.website}

              onChange={handleChange}

            />



            <CrudInput

              label="Latitude"

              name="latitude"

              type="number"

              value={form.latitude}

              onChange={handleChange}

            />



            <CrudInput

              label="Longitude"

              name="longitude"

              type="number"

              value={form.longitude}

              onChange={handleChange}

            />



          </div>



        </section>





        {/* =====================================================

            CATEGORIES

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            School Classification

          </h3>



          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">



            <CrudInput

              label="School Category"

              name="schoolCategory"

              value={form.schoolCategory}

              onChange={handleChange}

            />



            <CrudInput

              label="Target Category"

              name="targetCategory"

              value={form.targetCategory}

              onChange={handleChange}

              placeholder="A - Premium"

            />



            <CrudInput

              label="Last Verified Date"

              name="lastVerifiedDate"

              type="date"

              value={form.lastVerifiedDate}

              onChange={handleChange}

            />



          </div>



        </section>





        {/* =====================================================

            SCHOOL ASSIGNMENT

        ===================================================== */}



        <section>



          <h3 className="mb-2 text-lg font-bold text-navy-700">

            School Assignment

          </h3>



          <p className="mb-4 text-sm text-gray-500">

            Assign one or more active sales employees to this school.

          </p>





          <div className="max-h-64 overflow-y-auto rounded-xl border border-gray-200 p-4">



            {employeeLoading ? (



              <div className="py-5 text-center text-sm text-gray-500">

                Loading employees...

              </div>



            ) : employees.length === 0 ? (



              <div className="py-5 text-center text-sm text-gray-500">

                No active employees available.

              </div>



            ) : (



              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">



                {employees.map(

                  (employee) => {



                    const employeeId =

                      String(

                        employee.id

                      );



                    const checked =

                      (

                        form.assignedEmployeeIds ||

                        []

                      )

                        .map(String)

                        .includes(

                          employeeId

                        );





                    return (



                      <label

                        key={

                          employeeId

                        }

                        className="flex cursor-pointer items-center gap-3 rounded-xl border border-gray-200 p-3 hover:bg-gray-50"

                      >



                        <input

                          type="checkbox"

                          checked={

                            checked

                          }

                          onChange={(e) =>

                            handleEmployeeChange(

                              employeeId,

                              e.target.checked

                            )

                          }

                          className="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"

                        />



                        <div>



                          <div className="font-semibold text-gray-700">

                            {

                              employee.user?.name ||

                              employee.name ||

                              "Employee"

                            }

                          </div>



                          <div className="text-xs text-gray-400">

                            {

                              employee.employeeCode ||

                              employee.code ||

                              ""

                            }

                          </div>



                        </div>



                      </label>



                    );



                  }

                )}



              </div>



            )}



          </div>



        </section>





        {/* =====================================================

            BUSINESS DETAILS

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            Business Details

          </h3>



          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">



            <CrudInput

              label="Current Publisher"

              value={

                businessDetails.currentPublisher

              }

              onChange={(e) =>

                setBusinessDetails({

                  ...businessDetails,

                  currentPublisher:

                    e.target.value,

                })

              }

            />



            <CrudInput

              label="Existing Books"

              value={

                businessDetails.existingBooks

              }

              onChange={(e) =>

                setBusinessDetails({

                  ...businessDetails,

                  existingBooks:

                    e.target.value,

                })

              }

            />



            <CrudInput

              label="Competitor Books"

              value={

                businessDetails.competitorBooks

              }

              onChange={(e) =>

                setBusinessDetails({

                  ...businessDetails,

                  competitorBooks:

                    e.target.value,

                })

              }

            />



            <CrudInput

              label="Potential"

              value={

                businessDetails.potential

              }

              onChange={(e) =>

                setBusinessDetails({

                  ...businessDetails,

                  potential:

                    e.target.value,

                })

              }

            />



            <CrudInput

              label="Expected Order"

              value={

                businessDetails.expectedOrder

              }

              onChange={(e) =>

                setBusinessDetails({

                  ...businessDetails,

                  expectedOrder:

                    e.target.value,

                })

              }

            />



            <CrudInput

              label="Remarks"

              value={

                businessDetails.remarks

              }

              onChange={(e) =>

                setBusinessDetails({

                  ...businessDetails,

                  remarks:

                    e.target.value,

                })

              }

            />

            <CrudSelect
              label="Book Supplied Through"
              value={form.bookSuppliedThrough}
              onChange={(e) =>
                setForm({
                  ...form,
                  bookSuppliedThrough: e.target.value,
                })
              }
              options={[
                { value: "", label: "Select" },
                { value: "Direct", label: "Direct" },
                { value: "Bookseller", label: "Bookseller" },
                { value: "Distributer", label: "Distributer" },
              ]}
            />

            <CrudInput
              label="Book Seller Name"
              name="bookSellerName"
              value={form.bookSellerName}
              onChange={handleChange}
            />

            <CrudInput
              label="Sampling Time"
              name="samplingTime"
              type="time"
              value={form.samplingTime}
              onChange={handleChange}
            />

            <CrudInput
              label="Finalization Time"
              name="finalizationTime"
              type="time"
              value={form.finalizationTime}
              onChange={handleChange}
            />



          </div>



        </section>





        {/* =====================================================

            CONTACTS

        ===================================================== */}



        <section>



          <div className="mb-4 flex items-center justify-between">



            <div>



              <h3 className="text-lg font-bold text-navy-700">

                School Contacts

              </h3>



              <p className="mt-1 text-sm text-gray-500">

                Add principals, coordinators, purchase managers and other decision makers.

              </p>



            </div>





            <button

              type="button"

              onClick={

                addContact

              }

              className="rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-600"

            >

              + Add Contact

            </button>



          </div>





          <div className="space-y-4">



            {contacts.length ===

              0 ? (



              <div className="rounded-xl border border-dashed border-gray-300 p-6 text-center text-sm text-gray-500">

                No contacts added.

              </div>



            ) : (



              contacts.map(

                (

                  contact,

                  index

                ) => (



                  <div

                    key={

                      contact.id ||

                      index

                    }

                    className="rounded-2xl border border-gray-200 p-5"

                  >



                    <div className="mb-4 flex items-center justify-between">



                      <h4 className="font-semibold text-navy-700">

                        Contact #

                        {index + 1}

                      </h4>



                      <button

                        type="button"

                        onClick={() =>

                          removeContact(

                            index

                          )

                        }

                        className="text-sm font-semibold text-red-500"

                      >

                        Remove

                      </button>



                    </div>





                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">



                      <CrudInput

                        label="Name"

                        required

                        value={

                          contact.name

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "name",

                            e.target.value

                          )

                        }

                      />



                      <CrudInput

                        label="Designation"

                        value={

                          contact.designation

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "designation",

                            e.target.value

                          )

                        }

                      />



                      <CrudInput

                        label="Department"

                        value={

                          contact.department

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "department",

                            e.target.value

                          )

                        }

                      />



                      <CrudInput

                        label="Mobile"

                        value={

                          contact.phone

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "phone",

                            e.target.value

                          )

                        }

                      />



                      <CrudInput

                        label="Alternate Mobile"

                        value={

                          contact.alternateMobile

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "alternateMobile",

                            e.target.value

                          )

                        }

                      />



                      <CrudInput

                        label="Email"

                        type="email"

                        value={

                          contact.email

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "email",

                            e.target.value

                          )

                        }

                      />



                      <CrudInput

                        label="WhatsApp"

                        value={

                          contact.whatsapp

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "whatsapp",

                            e.target.value

                          )

                        }

                      />



                      <CrudInput

                        label="Decision Maker Level"

                        value={

                          contact.decisionMakerLevel

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "decisionMakerLevel",

                            e.target.value

                          )

                        }

                      />



                      <CrudSelect

                        label="Preferred Contact Method"

                        value={

                          contact.preferredContactMethod ||

                          ""

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "preferredContactMethod",

                            e.target.value

                          )

                        }

                        options={[

                          {

                            value: "",

                            label: "Select",

                          },

                          {

                            value: "Phone Call",

                            label: "Phone Call",

                          },

                          {

                            value: "WhatsApp",

                            label: "WhatsApp",

                          },

                          {

                            value: "Email",

                            label: "Email",

                          },

                          {

                            value: "SMS",

                            label: "SMS",

                          },

                        ]}

                      />



                      <CrudInput

                        label="Best Contact Time"

                        value={

                          contact.bestContactTime

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "bestContactTime",

                            e.target.value

                          )

                        }

                        placeholder="11:30 AM - 1:00 PM"

                      />



                      <CrudInput

                        label="Consent / Source"

                        value={

                          contact.consentSource

                        }

                        onChange={(e) =>

                          updateContact(

                            index,

                            "consentSource",

                            e.target.value

                          )

                        }

                      />



                      <label className="flex items-center gap-3 self-end pb-3 text-sm font-medium text-gray-700">



                        <input

                          type="checkbox"

                          checked={

                            Boolean(

                              contact.isPrimary

                            )

                          }

                          onChange={(e) =>

                            updateContact(

                              index,

                              "isPrimary",

                              e.target.checked

                            )

                          }

                        />



                        Primary Contact



                      </label>



                    </div>



                  </div>



                )

              )



            )}



          </div>



        </section>





        {/* =====================================================

            STATUS

        ===================================================== */}



        <section>



          <h3 className="mb-4 text-lg font-bold text-navy-700">

            Current Status

          </h3>



          <CrudSelect

            label="Status"

            value={

              form.status

            }

            onChange={(e) =>

              setForm({

                ...form,

                status:

                  e.target.value,

              })

            }

            options={[

              {

                value: "active",

                label: "Active",

              },

              {

                value: "inactive",

                label: "Inactive",

              },

              {

                value: "prospect",

                label: "Prospect",

              },

              {

                value: "closed",

                label: "Closed",

              },

            ]}

          />



        </section>



      </div>



    </CrudModal>

  );

}